export default __webpack_public_path__ + "static/media/assistance-gray.a4071dde.svg";